import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Countdown from 'react-countdown';
import ModalDecorator from 'hocs/ModalDecorator';
import { $ } from 'rype-bootstrap';
import moment from 'moment';

import { selectDay } from 'actions/filterActions';
import './style.css';

class TrialUpgradeModal extends Component {
  constructor() {
    super();
    $.noConflict();
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#trial-upgrade-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#trial-upgrade-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#trial-upgrade-modal').modal('hide');
  };

  goToActivate = (event) => {
    event.preventDefault();
    const { coupon } = this.props.modalProps;
    browserHistory.push(
      `/activate?plan=language_4_8pr&promo=${coupon.id}&src=upgradeModal`
    );
    this.close();
  };

  bookAnotherLesson = () => {
    const { appointment } = this.props.modalProps;
    const tomorrow = moment().add(1, 'day');
    this.props.selectDay(tomorrow);
    browserHistory.push(`/schedule-lesson/${appointment.teacher.slug}`);
    this.close();
  };

  countdownRenderer = ({
    days, hours, minutes, seconds, completed
  }) => {
    if (completed) {
      // Render a complete state
      return <div>Out of time!</div>;
    }
    // Render a countdown
    return (
      <span>
        {days} days : {hours} hours : {minutes} min : {seconds} sec
      </span>
    );
  };

  renderUpgrade() {
    const { coupon } = this.props.modalProps;
    const endsAt = coupon ? moment.unix(coupon.redeem_by) : null;

    return (
      <React.Fragment>
        <h4>
          {coupon ?
            `Get $${coupon.amount_off / 100} today` :
            'Upgrade Today'}
        </h4>
        <div className="mt-3 mb-3 ml-4 mr-4">
          {coupon ? (
            <Countdown
              date={endsAt.toDate()}
              renderer={this.countdownRenderer}
            />
          ) : (
            <h6>Choose a Rype Plan and reach your goals faster</h6>
          )}
        </div>
        {coupon && (
          <div className="small-text mb-2">
            Offer ends {endsAt.format('MMM DD, YYYY')}
          </div>
        )}
        <button
          type="button"
          className="btn btn-primary btn-lg btn-cursor w-100 mb-3"
          onClick={this.goToActivate}
        >
          {coupon ? 'Claim Offer' : 'Upgrade'}
        </button>
      </React.Fragment>
    );
  }

  render() {
    const { trialStatus } = this.props.modalProps;
    return (
      <div
        id="trial-upgrade-modal"
        className="TrialUpgradeModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="trial-upgrade-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img
                src="/assets/rype-logo-black.png"
                alt="logo"
                className="mb-3 mt-2 logo"
              />
              {trialStatus.status === 'credit_trial' && this.renderUpgrade()}
              {
                trialStatus.status === 'credit_trial' && trialStatus.creditsRemaining > 0 && (
                  <button
                    type="button"
                    className="btn btn-primary btn-lg btn-cursor w-100 mb-3"
                    onClick={this.bookAnotherLesson}
                  >
                    Book Another Lesson
                  </button>
                )
              }
              <Link
                to="#"
                className="text-underline m-auto"
                onClick={this.close}
              >
                Not right now
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalProps: state.visibleModal.props,
  };
}

export default compose(
  ModalDecorator('trial-upgrade-modal'),
  connect(mapStateToProps, { selectDay })
)(TrialUpgradeModal);



// WEBPACK FOOTER //
// ./src/components/modals/TrialUpgradeModal/index.js